import { PRODUCT_TYPES } from '../../../shared/constants/products';

const FACET_CONFIG = {
  ACCESSORY_CATEGORY: {
    facetSelectors: [
      (queryParams, routeParams, queryType, productType) => {
        if (
          productType === PRODUCT_TYPES.ACCESSORIES &&
          typeof queryParams.cat === 'string'
        ) {
          return queryParams.cat;
        }
      }
    ],
    filterSelectors: [
      (queryParams, routeParams, queryType, productType) => {
        // routeParams = tires/tire-accessories, values prior to / must be removed
        const validAccessoryRouteParam = /\//.test(routeParams?.[0])
          ? routeParams?.[0].split('/')[1]
          : routeParams?.[0];

        if (
          productType === PRODUCT_TYPES.ACCESSORIES &&
          queryType === 'CATEGORY_SEARCH'
        ) {
          return typeof validAccessoryRouteParam === 'string'
            ? `${validAccessoryRouteParam}-accessories`
            : '';
        }
      }
    ]
  },
  BRAND_NAME: {
    facetSelectors: [
      queryParams => {
        if (typeof queryParams.brand === 'string') {
          return queryParams.brand;
        }
      }
    ],
    filterSelectors: [
      (_, routeParams, queryType, productType) => {
        if (
          queryType === 'BRAND_SEARCH' &&
          typeof routeParams?.[0] === 'string' &&
          typeof productType === 'string'
        ) {
          return `${routeParams?.[0]}-${productType.toLowerCase()}`;
        }
      }
    ]
  },
  DEAL_REBATE: {
    facetSelectors: [
      queryParams => {
        if (queryParams.sort === 'onpromotion-asc') {
          return 'dealAndRebateFilters';
        }
      }
    ],
    filterSelectors: [
      queryParams => {
        if (queryParams.sort === 'onpromotion-asc') {
          return 'dealAndRebateFilters';
        }
      }
    ]
  },
  TIRE_ASPECT_RATIO: {
    filterSelectors: [
      (_, routeParams, queryType, productType) => {
        if (
          queryType === 'SIZE_SEARCH' &&
          productType === PRODUCT_TYPES.TIRES &&
          typeof routeParams?.size === 'string'
        ) {
          return routeParams.size.split('-')[1];
        }
      }
    ]
  },
  TIRE_CATEGORY: {
    facetSelectors: [
      (queryParams, routeParams, queryType, productType) => {
        if (
          productType === PRODUCT_TYPES.TIRES &&
          typeof queryParams.cat === 'string'
        ) {
          return queryParams.cat;
        }
      }
    ],
    filterSelectors: [
      (_, routeParams, queryType, productType) => {
        if (
          productType === PRODUCT_TYPES.TIRES &&
          queryType === 'CATEGORY_SEARCH'
        ) {
          return typeof routeParams?.[0] === 'string'
            ? `${routeParams[0]}-tires`
            : '';
        }
      }
    ]
  },
  TIRE_CROSS_SECTION: {
    filterSelectors: [
      (_, routeParams, queryType, productType) => {
        if (
          queryType === 'SIZE_SEARCH' &&
          productType === PRODUCT_TYPES.TIRES &&
          typeof routeParams?.size === 'string'
        ) {
          return routeParams.size.split('-')[0];
        }
      }
    ]
  },
  TIRE_WHEEL_DIAMETER: {
    filterSelectors: [
      (_, routeParams, queryType, productType) => {
        if (
          queryType === 'SIZE_SEARCH' &&
          productType === PRODUCT_TYPES.TIRES &&
          typeof routeParams?.size === 'string'
        ) {
          return routeParams.size.split('-')[2];
        }
      }
    ]
  },
  WHEEL_BOLT_PATTERN: {
    filterSelectors: [
      queryParams => {
        if (typeof queryParams.boltPattern === 'string') {
          return queryParams.boltPattern;
        }
      }
    ]
  },
  WHEEL_CATEGORY: {
    facetSelectors: [
      (queryParams, routeParams, queryType, productType) => {
        if (
          productType === PRODUCT_TYPES.WHEELS &&
          typeof queryParams.cat === 'string'
        ) {
          return queryParams.cat;
        }
      }
    ],
    filterSelectors: [
      (queryParams, routeParams, queryType, productType) => {
        if (
          productType === PRODUCT_TYPES.WHEELS &&
          queryType === 'CATEGORY_SEARCH'
        ) {
          return typeof routeParams?.[0] === 'string'
            ? `${routeParams[0]}-wheels`
            : '';
        }
      }
    ]
  },
  WHEEL_RIM_DIAMETER: {
    filterSelectors: [
      queryParams => {
        if (typeof queryParams.diameter === 'string') {
          return queryParams.diameter;
        }
      }
    ]
  },
  WHEEL_WHEEL_WIDTH: {
    filterSelectors: [
      queryParams => {
        if (typeof queryParams.width === 'string') {
          return queryParams.width;
        }
      }
    ]
  }
};

export function getFacetsAndFilters(
  queryParams,
  routeParams,
  queryType,
  productType
) {
  function selectFacetValues(facetName, selectorType) {
    const selectors = FACET_CONFIG[facetName][selectorType];
    return (Array.isArray(selectors) ? selectors : []).reduce(
      (accFacets, selector) => {
        const facetValue = selector(
          queryParams || {},
          routeParams || {},
          queryType,
          productType
        );
        if (facetValue && typeof facetValue === 'string') {
          accFacets.push({ facetName, facetValue });
        }
        return accFacets;
      },
      []
    );
  }

  const facetNames = Object.keys(FACET_CONFIG);
  return facetNames.reduce(
    (acc, facetName) => ({
      facets: acc.facets.concat(
        selectFacetValues(facetName, 'facetSelectors', queryParams, routeParams)
      ),
      filters: acc.filters.concat(
        selectFacetValues(
          facetName,
          'filterSelectors',
          queryParams,
          routeParams
        )
      )
    }),
    { facets: [], filters: [] }
  );
}
